/// <amd-module name="typeahead/features/UitkDropDownGeometryReplicatorForFlightSearchResults" />

/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/thirdparty/jquery/jquery.d.ts" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IDropDownHideHandler} from "typeahead/core/presentation/IDropDownHideHandler";
import {IDropDownShowHandler} from "typeahead/core/presentation/IDropDownShowHandler";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [{}];

export class UitkDropDownGeometryReplicatorForFlightSearchResults implements IDropDownHideHandler<undefined>,
        IDropDownShowHandler<undefined> {
    private static applicableClients: string[] = ["Flights.Search"];
    // @baseSpacingHorz as defined in uitoolkit; see uitoolkit/.../mixins.less (http://go/iuo39gal)
    private static baseSpacingHorz: number = 12;
    private static uitkTypeaheadWidthPx = 390;
    private static uitkTypeaheadMinWidthPx = 282;
    private static resizeEventTypes: string = "orientationchange resize";

    private static optimizeDropDownGeometry($dropDownElement: JQuery, $inputElement: JQuery): void {
        const availableMediaWidthPx: number =
            4 + document.body.clientWidth - UitkDropDownGeometryReplicatorForFlightSearchResults.baseSpacingHorz * 2;
        const maxDropDownWidthPx: number =
            4 +
            Math.min(UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadWidthPx, availableMediaWidthPx);
        const minDropDownWidthPx: number =
            4 +
            Math.min(UitkDropDownGeometryReplicatorForFlightSearchResults.uitkTypeaheadMinWidthPx,
                availableMediaWidthPx);
        const newWidth: number = Math.min(maxDropDownWidthPx, availableMediaWidthPx);
        let leftOffset: number = $inputElement.offset().left - 2;
        if (leftOffset + newWidth > availableMediaWidthPx) {
            leftOffset = UitkDropDownGeometryReplicatorForFlightSearchResults.baseSpacingHorz +
                availableMediaWidthPx - newWidth - 2;
            // 2px: The border of the autocomplete-dropdown is 2px narrower than that of the input
        }
        leftOffset = leftOffset - $inputElement.get(0).getBoundingClientRect().left;
        $dropDownElement.css({
            "left": leftOffset + "px",
            "max-width": maxDropDownWidthPx + "px",
            "min-width": minDropDownWidthPx + "px",
            "width": newWidth + "px",
        });
    }

    private showHandlers: {[inputElementId: string]: (event: JQueryEventObject) => any} = {};

    public handleDropDownHide($dropDownElement: JQuery, $inputElement: JQuery, context: IContext):
    JQueryPromise<undefined> {
        const inputElementId: string = $inputElement.attr("id");
        const showHandler = inputElementId ? this.showHandlers[inputElementId] : undefined;
        if (showHandler) {
            $(window).off(UitkDropDownGeometryReplicatorForFlightSearchResults.resizeEventTypes, null, showHandler);
            delete this.showHandlers[inputElementId];
        }
        let deferred: JQueryDeferred<undefined> = $.Deferred();
        return deferred.resolve().promise();
    }

    public handleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext):
    JQueryPromise<undefined> {
        const def: JQueryDeferred<undefined> = $.Deferred();
        if (UitkDropDownGeometryReplicatorForFlightSearchResults.applicableClients.indexOf(context.clientId) >= 0) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((result: boolean): void => {
                    if (result) {
                        this.doHandleDropDownShow($dropDownElement, $inputElement);
                    }
                })
                .always((): void => {
                    def.resolve(undefined);
                });
        } else {
            def.resolve(undefined);
        }
        return def.promise();
    }

    private doHandleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery): void {
        const optimizeDropDownGeometry = (event: JQueryEventObject): any => {
            UitkDropDownGeometryReplicatorForFlightSearchResults.optimizeDropDownGeometry($dropDownElement,
                $inputElement);
        };
        optimizeDropDownGeometry(null);
        $(window).on(UitkDropDownGeometryReplicatorForFlightSearchResults.resizeEventTypes,
            null, null, optimizeDropDownGeometry);
        const inputElementId: string = $inputElement.attr("id");
        if (inputElementId) {
            this.showHandlers[$inputElement.attr("id")] = optimizeDropDownGeometry;
        }
    }
}
